import { render } from "./Kuvvet.vue?vue&type=template&id=61eb7f9f"
import script from "./Kuvvet.vue?vue&type=script&lang=js"
export * from "./Kuvvet.vue?vue&type=script&lang=js"

import "./Kuvvet.vue?vue&type=style&index=0&id=61eb7f9f&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__